import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { ApplyModalProvider } from './components/ApplyModalContext';
import { ApplyModal } from './components/ApplyModal';
export function App() {
  return <ApplyModalProvider data-id="element-0">
      <LandingPage data-id="element-1" />
      <ApplyModal data-id="element-2" />
    </ApplyModalProvider>;
}